import http from "@/http-common";
import './security';


//Parametros
var user = JSON.parse(localStorage.getItem('user'));
var data = {};

class PanelConfigService {

    forceInstall() {
        return http.get("/panelconfig/seeder");
    }

    exportDB() {
        data = {
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
                let percentCompleted = (progressEvent.loaded / 1024 / 1024);
                sessionStorage.setItem('DumpProgressbar', percentCompleted.toFixed(2))
            }
        }
        return http.get("/database/export", data);
    }

    async importDB(formData) {
        return http.post("/database/import", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    getPanelConfig() {
        return http.get("/panelconfig")
    }

    updatePanelConfig(data) {
        return http.put("/panelconfig", data)
    }

    sendEmailTest(data) {
        return http.post("/panelconfig/sendemailtest", data)
    }

    sendSMSTest(data) {
        return http.post("/panelconfig/sendsmstest", data)
    }

}

export default new PanelConfigService();